<template>
  <div class="default-table">
    <div style="display: flex;flex-direction: row;justify-content: flex-start;gap: 5px;align-items: center">
      <div class="card-title">
        {{ title }}进度
        <el-link type="primary" icon="el-icon-refresh" @click="getList" style="margin-left: 10px;margin-right: 10px;">
          刷新
        </el-link>
      </div>
      <div style="line-height: 24px;font-size: 12px; font-weight: 500;display: inline-block;
      border: #fe346e 1px dashed;border-radius: 8px;padding: 2px 10px;margin-left: 20px">
        当月可结算收入=当月应发金额=当月确认直播GMV/保量金额*不含税收入
      </div>
    </div>

    <div style="width: 95%;margin: 0 auto;">
      <div class="default-table form-card"
           style="width: 100%;margin: unset;"
           v-loading="loading"
           element-loading-text="加载中……"
           element-loading-spinner="el-icon-loading">
        <el-table :data="table">
          <el-table-column label="核算归属月份" width="120" align="center">
            <template v-slot="{row:{date_check}}">
              <b v-if="date_check==='累计'">累计</b>
              <span v-else>{{ date_check|parseTime('{y}年{m}月') }}</span>
            </template>
          </el-table-column>
          <el-table-column label="红人" width="120" header-align="center" align="center">
            <template v-slot="{row:{artist}}">
              {{ artist ? artist.nickname : '-'}}
            </template>
          </el-table-column>
          <el-table-column label="平台" prop="platform" width="120" header-align="center" align="center" />
          <el-table-column :label="`${title}进度`" prop="stage_schedule" width="120" header-align="center" align="center">
            <template v-slot="{row:{stage_schedule}}">
              {{ stage_schedule|percentage(2) }}%
            </template>
          </el-table-column>
          <el-table-column label="实发金额" prop="stage_amount" width="120" header-align="center" align="center">
            <template v-slot="{row:{stage_amount}}">
              ￥{{ stage_amount|numberFormat(2) }}
            </template>
          </el-table-column>
          <el-table-column label="应发金额" prop="deserve_amount" width="120" header-align="center" align="center">
            <template v-slot="{row:{deserve_amount}}">
              ￥{{ deserve_amount|numberFormat(2) }}
            </template>
          </el-table-column>
<!--          <el-table-column label="实际应发金额" prop="rd_amount" width="120" header-align="center" align="center">-->
<!--            <template v-slot="{row:{rd_amount}}">-->
<!--              ￥{{ rd_amount|numberFormat(2) }}-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="差额" prop="diff_amount" width="120" header-align="center" align="center">
            <template v-slot="{row:{diff_amount, id}}">
              <span :style="`color:${red_tip.includes(id)?'red':''}`">
                ￥{{ diff_amount|numberFormat(2) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="分成比例" prop="artist_rate" width="120" header-align="center" align="center">
            <template v-slot="{row}">
              <span v-if="row.id === -1"></span>
              <span v-else>
                <el-link type="primary" v-if="userAuth.live_guarantee__record_add" @click="handleRow(row)">
                  {{ row.artist_rate|numberFormat(2) }}%
                </el-link>
                <b v-else>{{ row.artist_rate|numberFormat(2) }}%</b>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="分成金额" prop="artist_rate_amount" width="120" header-align="center" align="center">
            <template v-slot="{row:{artist_rate_amount}}">
              ￥{{ artist_rate_amount|numberFormat(2) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog :title=recordUpd.title :visible.sync="recordUpd.show" width="600px" center custom-class="live-data-dialog">
        <div class="form-card-box">
          <el-form ref="form" :model="recordUpd.formData">
            <el-form-item label="红人分成比例" :prop="'artist_rate'" required>
              <el-input class="el-input-c" v-model="recordUpd.formData.artist_rate" placeholder="红人分成比例" clearable />
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="recordUpd.show = false">取 消</el-button>
          <el-button type="primary" @click="onSubmitRecordUpd">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {liveGuaranteeRecordUpd, liveGuaranteeTheOrderSchedule} from "@/api/liveGuarantee";

export default {
  name: 'LiveDataSchedule',
  props: {
    orderId: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth
    },
  },
  data() {
    return {
      loading: false,
      table: [],
      red_tip: {},
      title: '',
      recordUpd: {
        show: false,
        title: '',
        formData: {
          id: null,
          artist_rate: null,
        },
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList: async function () {
      this.loading = true
      const {model:{title,table, red_tip}} = await liveGuaranteeTheOrderSchedule({order_id: this.orderId})
      this.loading = false
      this.table = table
      this.title = title
      this.red_tip = red_tip||[]
    },
    handleRow(row) {
      let t = new Date(row.date_check + 'T00:00:00')
      t = t.getFullYear() + '年' + (t.getMonth() + 1) + '月'
      this.recordUpd.title = '【' + row.artist.nickname + '-' + row.platform + '】' + t + '的分成比例'
      this.recordUpd.formData = {
        id: row.id,
        artist_rate: row.artist_rate,
      }
      this.recordUpd.show = true
    },
    onSubmitRecordUpd() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          // this.onSubmitLoading = true
          liveGuaranteeRecordUpd(this.recordUpd.formData).then((res) => {
            if (res.success) {
              this.showToast({
                h: this,
                text: '更新成功'
              });
              this.recordUpd.show = false
              this.recordUpd.title = ''
              this.recordUpd.formData = {id: null, artist_rate: null}
              this.getList()
            }
          })
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    }
  }
}
</script>
<style scoped>

</style>
<style lang="scss">
.live-data-dialog {
  .el-input, .el-select {
    width: calc(100% - 120px);
  }

  .el-select {
    .el-input {
      width: 100%;
    }
  }
}
</style>